function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import * as styles from './expander.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
const transitionExpanderTo = _ref => {
  let contentHeight = _ref.contentHeight,
    overflow = _ref.overflow;
  return (prevState, _ref2) => {
    let expanded = _ref2.expanded,
      expandedHeight = _ref2.expandedHeight,
      isDisabled = _ref2.isDisabled;
    let maxHeight;
    if (expanded) {
      if (typeof contentHeight !== 'undefined') {
        maxHeight = contentHeight;
      }
    } else if (typeof expandedHeight !== 'undefined') {
      maxHeight = Math.max(expandedHeight, 0);
    } else if (!isDisabled) {
      maxHeight = 0;
    }
    if (typeof maxHeight !== 'undefined') {
      maxHeight = "".concat(maxHeight, "px");
    }
    return {
      maxHeight,
      overflow: overflow || 'hidden'
    };
  };
};
const getInitialState = transitionExpanderTo({});
class Expander extends React.PureComponent {
  constructor(props) {
    super(props);
    _defineProperty(this, "_wrapper", void 0);
    _defineProperty(this, "_content", void 0);
    _defineProperty(this, "cancelTimeout", void 0);
    _defineProperty(this, "setContent", ref => {
      this._content = ref;
      if (this._content !== null) {
        var _this$props$onInitial, _this$props;
        const contentHeight = this._content.clientHeight;
        (_this$props$onInitial = (_this$props = this.props).onInitialHeight) === null || _this$props$onInitial === void 0 ? void 0 : _this$props$onInitial.call(_this$props, contentHeight);
        if (this.props.expanded) {
          this.updateExpanderState({
            overflow: 'visible'
          });
        }
      }
    });
    _defineProperty(this, "setWrapper", ref => {
      this._wrapper = ref;
    });
    _defineProperty(this, "handleTransitionEnd", () => {
      if (this.props.expanded) {
        this.updateExpanderState({
          overflow: 'visible'
        });
      } else if (this.props.hideCollapsedContent && this._wrapper) {
        this._wrapper.style.display = 'none';
      }
    });
    this.state = getInitialState({}, props);
  }
  componentDidUpdate(prevProps) {
    if (this.isCollapsing(prevProps)) {
      this.setWrapperMaxHeight(this.getWrapperHeight());
      this.cancelTimeout = window.setTimeout(() => this.updateExpanderState({
        contentHeight: this.getContentHeight()
      }), 50);
    }
    if (this.isExpanding(prevProps) || this.props.expandedHeight !== prevProps.expandedHeight) {
      this.updateExpanderState({
        contentHeight: this.getContentHeight()
      });
    }
  }
  componentDidMount() {
    if (this.props.hideCollapsedContent && !this.props.expanded && this._wrapper) {
      this._wrapper.style.display = 'none';
    }
  }
  componentWillUnmount() {
    window.clearTimeout(this.cancelTimeout);
  }
  getContentHeight() {
    var _this$_content;
    if (this.props.hideCollapsedContent && this._wrapper) {
      this._wrapper.style.display = 'flex';
    }
    return (_this$_content = this._content) === null || _this$_content === void 0 ? void 0 : _this$_content.clientHeight;
  }
  setWrapperMaxHeight(wrapperHeight) {
    if (this._content) {
      this._content.style.maxHeight = "".concat(wrapperHeight, "px");
    }
  }
  getWrapperHeight() {
    var _this$_wrapper;
    return (_this$_wrapper = this._wrapper) === null || _this$_wrapper === void 0 ? void 0 : _this$_wrapper.clientHeight;
  }
  isExpanding(prevProps) {
    return this.props.expanded && !prevProps.expanded;
  }
  isCollapsing(prevProps) {
    return !this.props.expanded && prevProps.expanded;
  }
  updateExpanderState(nextState) {
    this.setState(transitionExpanderTo(nextState));
  }
  render() {
    const _this$props2 = this.props,
      children = _this$props2.children,
      expanded = _this$props2.expanded,
      isGradient = _this$props2.isGradient,
      id = _this$props2.id;
    const _this$state = this.state,
      overflow = _this$state.overflow,
      maxHeight = _this$state.maxHeight;
    return ___EmotionJSX("div", {
      "data-testid": "expander-wrapper",
      css: styles.wrapper({
        fade: !expanded && isGradient
      }),
      style: {
        maxHeight,
        overflow
      },
      ref: this.setWrapper,
      onTransitionEnd: this.handleTransitionEnd,
      className: "noscript-expander-wrapper",
      id: id
    }, ___EmotionJSX("div", {
      css: styles.content(expanded),
      "data-testid": "expander-content",
      className: "noscript-expander-content"
    }, ___EmotionJSX("div", {
      ref: this.setContent
    }, children)));
  }
}
_defineProperty(Expander, "defaultProps", {
  id: 'collapsible-panel',
  isGradient: true,
  expanded: true,
  expandedHeight: undefined,
  onInitialHeight: () => {},
  isDisabled: false,
  hideCollapsedContent: false
});
export default Expander;